import { HTMLAttributes } from "react"

import { Translate } from "../translate"
import { BaseTypographyProps } from "./types"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type H2Props = BaseTypographyProps & HTMLAttributes<HTMLHeadingElement>

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const H2 = ({ i18nKey, values, formats, ...props }: H2Props) => {
  return (
    <h2 {...props}>
      <Translate i18nKey={i18nKey} values={values} formats={formats} />
    </h2>
  )
}

export { H2 }
